import React, { useRef, useLayoutEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./BannerSlider.css";
import slider01 from "../images/img/Connect.png";
import slider02 from "../images/img/Videsh.png";
import slider03 from "../images/img/PaceX.png";

import { Navigation, Pagination, Autoplay  } from "swiper/modules";

const RBannerSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const navigate = useNavigate();
const images = [
  { src: slider01, link: "https://seller.parcelx.in/register" },
  { src: slider02, link: "parcel-videsh" },
  { src: slider03, link: "pacex" },
  { src: slider01, link: "https://seller.parcelx.in/register" },
  { src: slider02, link: "parcel-videsh" },
  { src: slider03, link: "pacex" }
];
  useLayoutEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      const swiper = swiperRef.current;
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
      swiper.update();
    }
  }, []);

  return (
    <section className="section03 d-sm-none d-block">
      <div
        className="container-fluid px-0 position-relative"
        style={{ overflow: "visible" }}
      >
        <Swiper
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slideToClickedSlide={true}
          allowTouchMove={false}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          modules={[Navigation, Pagination, Autoplay]}
          onSwiper={(swiper) => { swiperRef.current = swiper; }}

          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
              centeredSlides: false
            },
            576: {
              slidesPerView: 1.3,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 1.3,
              spaceBetween: 30
            },
            1024: {
              slidesPerView: 1.4,
              spaceBetween: 40
            },
            1440: {
              slidesPerView: 1.5,
              spaceBetween: 60,
              centeredSlides: true
            }
          }}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <a href={img.link}>
                <img
                  src={img.src}
                  alt={`slide${index + 1}`}
                  className="img-fluid features-img"
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>


        <button ref={prevRef} className="features-slider custom-prev  position-absolute top-50 start-0 translate-middle-y" style={{ zIndex: 10 }}>
          ‹
        </button>
        <button
          ref={nextRef}
          className="features-slider custom-next  position-absolute top-50 end-0 translate-middle-y"
          style={{ zIndex: 10 }}
        >
          ›
        </button>
      </div>
    </section>
  );
};
export default RBannerSlider;
